import React, { Component, Fragment } from 'react';
import CanvasJSReact from '../assets/inc/canvasjs.react';
var CanvasJSChart = CanvasJSReact.CanvasJSChart;
 
class LineChart extends Component {
	render() {
		const options = {
			animationEnabled: true,
			// exportEnabled: true,
			theme: "light2", // "light1", "dark1", "dark2"
			// title:{
			// 	text: "Bounce Rate by Week of Year"
			// },
			axisY: {
				title: "",
				includeZero: false,
				suffix: "%"
			},
			toolTip: {
				shared: true
			},
			// axisX: {
			// 	title: "Week of Year",
			// 	prefix: "W",
			// 	interval: 2
			// },
			data: [{
				type: "line",
				name: "Mathematics",
				toolTipContent: "Week {x}: {y}%",
				showInLegend: true,
				dataPoints: [
					{ x: 1, y: 64 },
					{ x: 2, y: 61 },
					{ x: 3, y: 64 },
					{ x: 4, y: 62 },
					{ x: 5, y: 64 },
					{ x: 6, y: 64 },
					{ x: 7, y: 64 },
					{ x: 8, y: 64 },
					{ x: 9, y: 64 },
					{ x: 10, y: 65 },
					{ x: 11, y: 65 },
					{ x: 12, y: 50 },
					{ x: 13, y: 43 },
					{ x: 14, y: 43 },
					{ x: 15, y: 60 },
					{ x: 16, y: 42 },
					{ x: 17, y: 50 },
					{ x: 18, y: 59 },
					{ x: 19, y: 60 },
					{ x: 20, y: 45 },
					{ x: 21, y: 35 },
					{ x: 22, y: 40 },
					{ x: 23, y: 70 }
				]
			},{
				type: "line",
				name: "English",
				toolTipContent: "Week {x}: {y}%",
				showInLegend: true,
				dataPoints: [
					{ x: 1, y: 60 },
					{ x: 2, y: 62 },
					{ x: 3, y: 63 },
					{ x: 4, y: 60 },
					{ x: 5, y: 65 },
					{ x: 6, y: 63 },
					{ x: 7, y: 70 },
					{ x: 8, y: 60 },
					{ x: 9, y: 64 },
					{ x: 10, y: 58 },
					{ x: 11, y: 61 },
					{ x: 12, y: 60 },
					{ x: 13, y: 55 },
					{ x: 14, y: 60 },
					{ x: 15, y: 56 },
					{ x: 16, y: 60 },
					{ x: 17, y: 60 },
					{ x: 18, y: 63 },
					{ x: 19, y: 58 },
					{ x: 20, y: 54 },
					{ x: 21, y: 59 },
					{ x: 22, y: 64 },
					{ x: 23, y: 60 }
				]
			}]
		}
		
		return (
			<Fragment>
				<div className="flexDisplay alignFlex justifyFlexSpaceBtw listItem">
					<span className="elevenFontSize font500"> Time spent on test</span>
					<span className="elevenFontSize font500"> Month</span>
					{/* <div className=""></div> */}
				</div>
			<CanvasJSChart options = {options} className="rating2"  />
			</Fragment>
			
		);
	}
}

export default LineChart;                         